export default "__VITE_ASSET__WpIuunn8__"